module.exports = __webpack_public_path__ + "static/media/icon-blacklist.284f6bd0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/type-filters/icon-blacklist.svg
// module id = 529
// module chunks = 0